import { red, green, blue, yellow, orange } from "@material-ui/core/colors";
const value = 500
const status = {
  CANCELED: "Cancelado",
  DONE: "Surtido",
  ACTIVE: "Activo",
  ACCEPTED: "Aceptado",
  ROUTED: "En Ruta",
};

const statusOrder = {
  CANCELED: {
    status: 'CANCELED',
    label: 'Cancelado',
    color: red[value],
    symbol: '❌'
  },
  DONE: {
    status: 'DONE',
    label: 'Surtido',
    color: green[value],
    symbol: '✓'
  },
  ACTIVE: {
    status: 'ACTIVE',
    label: 'Activo',
    color: blue[value],
    symbol: '💡'
  },
  ACCEPTED: {
    status: 'ACCEPTED',
    label: 'Aceptado',
    color: yellow[value],
    symbol: '✔️'
  },
  ROUTED: {
    status: 'ROUTED',
    label: 'En Ruta',
    color: orange[value],
    symbol: '🗺️' 
  }
};

const statusAlter = {
  CANCELADO: "CANCELED",
  SURTIDOS: "DONE",
  ACTIVO: "ACTIVE",
};
const statusStyle = {
  CANCELADO: "status-cancelled",
  SURTIDO: "status-assortment",
  ACTIVO: "status-captured",
};
const statusCombo = [
  { value: "ACCEPTED", label: "Aceptado" },
  { value: "ACTIVE", label: "Activo" },
  { value: "CANCELED", label: "Cancelado" },
  { value: "ROUTED", label: "En Ruta" },
  { value: "DONE", label: "Surtido" },
];

export { status, statusAlter, statusStyle, statusCombo, statusOrder };
